import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Button, Arrange, Typography } from "@aviary";
import { useHasCatalogSearchShared } from "@shared/hooks/useHasCatalogSearchShared/useHasCatalogSearchShared";
import { l } from "@shared/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ClearFiltersButton.styles";

interface Props {
  onClearFilters?: () => void;
  withMargin?: boolean;
}

const ClearFiltersButton = ({ onClearFilters, withMargin }: Props) => {
  const { t } = useTranslation();

  const hasSearch = useHasCatalogSearchShared(false);

  if (onClearFilters && hasSearch) {
    return (
      <Button
        isColor="system"
        isOutlined
        onClick={onClearFilters}
        css={[withMargin && styles.clearFilters]}
      >
        <Arrange spacing="xsmall" alignment="center">
          <FontAwesomeIcon icon={faXmark} />
          <Typography>{t(l.sharedCatalog.ClearFilters)}</Typography>
        </Arrange>
      </Button>
    );
  }

  return null;
};

export { ClearFiltersButton };
